import store from '@/store';
import ConstCode from '@/common/constants/ConstCode';
import routerInstance from '@/router/index';

const tokenCheck = (to, from, next) => {
  const accessToken = store.getters['admin/accessToken'];
  return !(!accessToken && to.path !== '/' && to.path !== '/login');
};

const sessionInvalidateCheck = (to, from, next) => {
  if (process.env.NODE_ENV !== 'production') return true;

  const start = store.getters['admin/keepAlive'];
  const now = new Date().getTime();
  if (to.path === '/' || to.path === '/login') return true;
  if (!start) return false;
  return !((to.path !== '/' || to.path !== '/login') && now - start > ConstCode.SESSION_TIME_OUT.nHour(1));
};

const notRegisteredRoutePath = (to, from, next) => {
  return routerInstance.hasRoute(to.name);
};

const keepAliveCheck = (to, from) => {
  const orderPath = '/order';
  const storePath = '/store';
  const productPath = '/product';

  const keepAlivePaths = [orderPath, storePath, productPath];

  keepAlivePaths.forEach((path) => {
    if (from.path.includes(path) && !to.path.includes(path)) {
      console.log('clearKeepAlive', path);
      store.dispatch('layout/clearKeepAlive');
    }
  });
};

export { tokenCheck, sessionInvalidateCheck, notRegisteredRoutePath, keepAliveCheck };
